module.exports = __webpack_public_path__ + "img/children-1.ac72f1e5.jpg";